const init = () => {
    const contentContainer = document.querySelector('.js-wysiwyg-container');

    const links = contentContainer?.querySelectorAll('a');

    links?.forEach((link) => {
        link.classList.add('link');
        link.classList.add('link--underlined');
    });

    if (!CSS.supports('aspect-ratio', '16/9')) {
        const iframes = contentContainer?.querySelectorAll('iframe');

        iframes?.forEach((iframe) => {
            const responsiveWrapper = document.createElement('div');
            responsiveWrapper.classList.add('responsive');

            iframe.classList.add('responsive__item');

            iframe.parentNode?.insertBefore(responsiveWrapper, iframe);
            responsiveWrapper.appendChild(iframe);
        });
    }
};

const _module = { init };

export default _module;
